import { Timestamp } from "firebase/firestore";

/**
 * Momento da confirmação da compra, inclusive cupom de 100%/valor R$ 0.
 * Uma compra já paga não recebe data retroativa durante retries ou keep_alive.
 */
export function registrarCompraPaga(compra, agora = new Date()) {
  if (compra.pago === true) return compra;
  compra.pago = true;
  if (!compra.pago_em) compra.pago_em = Timestamp.fromDate(agora);
  return compra;
}

/** Compra concluída sem cobrança: cupom integral ou preço cadastrado em zero. */
export function registrarCompraGratuita(compra, agora = new Date()) {
  if (
    !compra ||
    typeof compra.valor !== "number" ||
    !Number.isFinite(compra.valor) ||
    compra.valor !== 0
  ) {
    throw new Error("Compra gratuita exige valor final zero.");
  }
  if (compra.origem_pagamento !== "EVENTO") {
    compra.origem_pagamento = compra.cupom?.id
      ? "CUPOM_INTEGRAL"
      : "PRECO_ZERO";
  }
  return registrarCompraPaga(compra, agora);
}
